import React from "react";
import { Formik } from "formik";
import Loader from "../../Loader/Loader";
import InputFormItem from "../../FormItems/items/InputFormItem";
import Widget from "../../Widget/Widget";
import { connect } from "react-redux";
import * as yup from "yup";

const ChangePasswordForm = (props) => {
  const { isEditing, findLoading, record, serverError } = props;

  const initialValues = {
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  };

  const handleSubmit = (values) => {
    const { ...data } = values || {};
    props.onSubmit(data);
  };

  const passwordSchema = {
    currentPassword: { type: "string", label: "Current Password" },
    newPassword: { type: "string", label: "New Password" },
    confirmNewPassword: { type: "string", label: "Confirm New Password" },
  };

  const changePasswordValidationSchema = yup.object().shape({
    currentPassword: yup
      .string()
      .required("Current password is required"),

    newPassword: yup
      .string()
      .min(6, "New password must be at least 6 characters")
      .required("New password is required"),

    confirmNewPassword: yup
      .string()
      .oneOf([yup.ref("newPassword")], "Passwords must match")
      .required("Please confirm your new password"),
  });

  const renderForm = () => {
    return (
      <Widget className="widget-p-md">
        {serverError && (
          <div className="alert alert-danger">{serverError}</div>
        )}
        <Formik
          onSubmit={handleSubmit}
          initialValues={initialValues}
          validationSchema={changePasswordValidationSchema}
        >
          {(form) => {
            return (
              <form onSubmit={props.handleSubmit}>
                <InputFormItem
                  name={"currentPassword"}
                  password
                  schema={passwordSchema}
                />

                <InputFormItem
                  name={"newPassword"}
                  schema={passwordSchema}
                  password
                />

                <InputFormItem
                  name={"confirmNewPassword"}
                  schema={passwordSchema}
                  password
                />
                <div>
                  <button
                    className="btn btn-primary mr-3"
                    // disabled={saveLoading}
                    type="button"
                    onClick={form.handleSubmit}
                  >
                    {" "}
                    Change Password
                  </button>{" "}
                  <button
                    className="btn btn-secondary"
                    type="button"
                    // disabled={saveLoading}
                    onClick={() => props.onCancel()}
                  >
                    {" "}
                    Cancel
                  </button>
                </div>
              </form>
            );
          }}
        </Formik>
      </Widget>
    );
  };

  if (findLoading) {
    return <Loader />;
  }

  if (isEditing && !record) {
    return <Loader />;
  }

  return renderForm();
};

function mapStateToProps(store) {
  return {
    findLoading: store.users.form.findLoading,
    saveLoading: store.users.form.saveLoading,
    record: store.users.form.record,
    currentUser: store.auth.currentUser,
  };
}

export default connect(mapStateToProps)(ChangePasswordForm);

//export default ChangePasswordForm;
